module.exports = __webpack_public_path__ + "img/home_logo.7fc0d3d3.png";